<template>

    <m-edit1/>

    <m-factor-2 v-bind='{...{"enableOverRightPrintStyle":true,"customPrintStyle":"@font-face { font-family: KalamehWebFaNum-SemiBold; src: url(\"https:\/\/cdn.mxit.ir\/fonts\/KalamehWebFaNum-SemiBold\/KalamehWebFaNum-SemiBold.eot\"); src: url(\"https:\/\/cdn.mxit.ir\/fonts\/KalamehWebFaNum-SemiBold\/KalamehWebFaNum-SemiBold.eot\") format(\"embedded-opentype\"), url(\"https:\/\/cdn.mxit.ir\/fonts\/KalamehWebFaNum-SemiBold\/KalamehWebFaNum-SemiBold.woff2\") format(\"woff2\"), url(\"https:\/\/cdn.mxit.ir\/fonts\/KalamehWebFaNum-SemiBold\/KalamehWebFaNum-SemiBold.woff\") format(\"woff\"), url(\"https:\/\/cdn.mxit.ir\/fonts\/KalamehWebFaNum-SemiBold\/KalamehWebFaNum-SemiBold.ttf\") format(\"truetype\"); } body *{ font-family: KalamehWebFaNum-SemiBold !important; }"},...{}}' :style='""' class="bg-white container" ></m-factor-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor2';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
